;(function () {
  angular
    .module('contrast.auth')
    .factory('sessionTimeoutInterceptor', [
      '$q',
      '$timeout',
      '$rootScope',
      'AuthCookieService',
      'TIMEOUT_EVENT',
      sessionTimeoutInterceptor
    ])

  function sessionTimeoutInterceptor(
    $q,
    $timeout,
    $rootScope,
    AuthCookieService,
    TIMEOUT_EVENT
  ) {
    var expirationRequest

    return {
      response: handleResponse,
      responseError: handleErrorResponse
    }

    function handleResponse(response) {
      checkExpiration()
      return response
    }

    function handleErrorResponse(response) {
      checkExpiration()
      return $q.reject(response)
    }

    function checkExpiration() {
      if (AuthCookieService.isSessionActive()) {
        var expiration = AuthCookieService.getSessionExpiration()
        if (expiration > 0) {
          cancelExpirationRequest()
          expirationRequest = $timeout(function () {
            $rootScope.$broadcast(TIMEOUT_EVENT)
          }, expiration + 1000)
        }
      }
    }

    function cancelExpirationRequest() {
      if (expirationRequest) {
        $timeout.cancel(expirationRequest)
        expirationRequest = null
      }
    }
  }
})()
